import React from 'react';

const backToTop = () => (
  <a href="#" className="back-to-top js--back-to-top">
    <i className="back-to-top__icon icon icon-arrow-up"></i>
  </a>
);

export default backToTop;